import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { IngredientsServices } from "../../../services";

@Component({
    selector: 'page-ingredient-partial-tags',
    templateUrl: 'ingredient-partial-tags.html',
})
export class IngredientPartialTagsPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public ingredientServices: IngredientsServices) {

    }

    onChange(val) {
        this.ingredientServices.ingredient_tags = val;
    }

    addTag(tag) {
        if (!(this.ingredientServices.ingredient_tags.indexOf(tag) > -1)) {
            if (tag != 'eti') {
                this.ingredientServices.ingredient_tags.push(tag);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-create/ingredient-create-info/ingredient-partial-tags/ingredient-partial-tags.ts